export const colors = {
  primary: {
    main: '#129FDB',
    light: '#5AC7F3',
    dark: '#0A78A8',
    contrastText: '#FFFFFF',
  },
  secondary: {
    main: '#F3F3F3',
    light: '#FAFAFA',
    dark: '#B2B2B2',
    contrastText: '#263238',
  },
  neutral: {
    0: '#000000',
    100: '#1C1C1E',
    200: '#2C2C2E',
    300: '#3A3A3C',
    400: '#48484A',
    500: '#636366',
    600: '#8E8E93',
    700: '#C7C7CC',
    800: '#E5E5EA',
    900: '#F2F2F7',
    1000: '#FFFFFF',
  },
  success: {
    main: '#4CAF50',
    light: '#81C784',
    dark: '#388E3C',
    contrastText: '#FFFFFF',
  },
  error: {
    main: '#F44336',
    light: '#E57373',
    dark: '#C62828',
    contrastText: '#FFFFFF',
  },
  warning: {
    main: '#FF9800',
    light: '#FFB74D',
    dark: '#F57C00',
    contrastText: '#000000',
  },
  info: {
    main: '#2196F3',
    light: '#64B5F6',
    dark: '#1976D2',
    contrastText: '#FFFFFF',
  },
  header: {
    background: '#fffbf3c7',
  },
  footer: {
    background: '#fffbf3c7',
  },
  background: {
    default: '#FAFAFA',
    paper: '#e4e4e4b0',
    elevated: '#F5F5F5', // #e4e4e48c #F5F5F5
  },
  text: {
    primary: '#263238',
    secondary: '#636366',
    disabled: '#8E8E93',
    hint: '#C7C7CC',
  },
  divider: '#E5E5EA',
  action: {
    active: '#129FDB',
    hover: 'rgba(18, 159, 219, 0.08)',
    selected: 'rgba(18, 159, 219, 0.12)',
    disabled: 'rgba(0, 0, 0, 0.26)',
    disabledBackground: 'rgba(0, 0, 0, 0.12)',
  },
};

export const darkColors = {
  primary: {
    main: '#5AC7F3',
    light: '#8DD7F7',
    dark: '#129FDB',
    contrastText: '#000000',
  },
  header: {
    background: '#1C1C1E',
  },
  footer: {
    background: '#1C1C1E',
  },
  secondary: {
    main: '#2C2C2E',
    light: '#3A3A3C',
    dark: '#1C1C1E',
    contrastText: '#FFFFFF',
  },
  neutral: {
    0: '#FFFFFF',
    100: '#F2F2F7',
    200: '#E5E5EA',
    300: '#C7C7CC',
    400: '#8E8E93',
    500: '#636366',
    600: '#48484A',
    700: '#3A3A3C',
    800: '#2C2C2E',
    900: '#1C1C1E',
    1000: '#000000',
  },
  success: {
    main: '#66BB6A',
    light: '#81C784',
    dark: '#4CAF50',
    contrastText: '#000000',
  },
  error: {
    main: '#EF5350',
    light: '#E57373',
    dark: '#F44336',
    contrastText: '#FFFFFF',
  },
  warning: {
    main: '#FFA726',
    light: '#FFB74D',
    dark: '#FF9800',
    contrastText: '#000000',
  },
  info: {
    main: '#42A5F5',
    light: '#64B5F6',
    dark: '#2196F3',
    contrastText: '#000000',
  },
  background: {
    default: '#000000',
    paper: '#1C1C1E', // #020f0eb0 #1c1c1ee8 1C1C1E
    elevated: '#2C2C2E',
  },
  text: {
    primary: '#FFFFFF',
    secondary: '#C7C7CC',
    disabled: '#636366',
    hint: '#48484A',
  },
  divider: '#48484A',
  action: {
    active: '#5AC7F3',
    hover: 'rgba(90, 199, 243, 0.08)',
    selected: 'rgba(90, 199, 243, 0.12)',
    disabled: 'rgba(255, 255, 255, 0.26)',
    disabledBackground: 'rgba(255, 255, 255, 0.12)',
  },
};
